import React from 'react';

import CardHOC from './Components/CardHOC';
import ShortText from '../../../Types/Components/ShortText';

const ShortTextCanvas = ({ index, question }) => {
  return <CardHOC index={index} question={question}>
    <ShortText question={question} />
  </CardHOC>
}

export default ShortTextCanvas;